import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntercomModule } from './intercom/intercom.module';
import { VelaroModule } from './velaro/velaro.module';
import { ZendeskModule } from './zendesk/zendesk.module';
import { ChatConfigService } from './services/chat-config.service';
import { ActiveChatService } from './services/active-chat.service';
import { ChatRunService } from './run/chat.run.service';
import { ForethoughtModule } from '@client/app/modules/chat/forethought/forethought.module';

export function initializeChatService (chatRunService: ChatRunService): () => Promise<void> {
    return () => chatRunService.initialize();
}

@NgModule({
    imports: [
        CommonModule,
        IntercomModule,
        VelaroModule,
        ZendeskModule,
        ForethoughtModule,
    ],
    exports: [
        IntercomModule,
        VelaroModule,
        ZendeskModule,
        ForethoughtModule,
    ],
    providers: [
        ChatConfigService,
        ActiveChatService,
        ChatRunService,
        provideAppInitializer(() => {
            const initializerFn = (initializeChatService)(inject(ChatRunService));
            return initializerFn();
        }),
    ],
})
export class ChatModule { }
